import React from 'react';

// This hook simply keeps tracking of a state changes & updates the ref accordingly
export const useStateRef = (state, defaultValue) => {
  const ref = React.useRef(defaultValue ?? state);

  React.useEffect(() => {
    ref.current = state;
  }, [state]);

  return ref;
};
